module.exports = __webpack_public_path__ + "static/img/3-role.b7ff7ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/3-role.png
// module id = gLwE
// module chunks = 1